import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State } from './feature-flag.state';
import { FeatureFlagKey } from '@surface-elements/shared/shared-util';

export const getFeatureFlagState = createFeatureSelector<State>('featureFlags');

export const selectAllFlags = createSelector(
  getFeatureFlagState,
  state => state.flags,
);

export const selectLoaded = createSelector(
  getFeatureFlagState,
  state => state.loaded,
);

export const selectError = createSelector(
  getFeatureFlagState,
  state => state.error,
);

/**
 * Factory selector: returns true/false for a specific flag key.
 * Returns false if the flag is unknown or flags haven't loaded.
 */
export const selectFlag = (key: FeatureFlagKey) =>
  createSelector(selectAllFlags, flags => flags[key] ?? false);
